import { GeckoComponentDataFrame, GeckoSource, GeckoView } from 'types'

export function isInspectionThicknessCDF(cdf: GeckoComponentDataFrame) {
  return (
    cdf.data.params.view === GeckoView.Thickness &&
    cdf.data.params.source !== GeckoSource.Projection &&
    cdf.data.params.source !== GeckoSource.TMin &&
    cdf.data.params.source !== GeckoSource.Nominal
  )
}
